import { memo } from "react";
import style from "../Assets/Styles/loading.module.css"
const Loading = () => {
    return (
      <div className="loading container-fluid">
        <div className="container-fluid text-center d-flex justify-content-center">
          <div className={style.ldsEllipsis}><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
    );
}
 
export default memo(Loading);